import { useQuery } from '@apollo/client/react';
import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  useLocation,
} from 'react-router-dom';
import Admin from '../components/Admin';
import PrivateRoute from '../components/PrivateRoute';
import SignIn from '../components/SignIn';
import { SelfDocument } from '../graphql/types';

const AppIndex: React.FC = () => {
  const { data } = useQuery(SelfDocument, { fetchPolicy: 'cache-first' });

  const isTestDataCreatorOnly =
    data?.self?.isTestDataCreator &&
    !data?.self?.isAdmin &&
    !data?.self?.isExerciseEditor;

  if (isTestDataCreatorOnly) {
    return <Navigate to="/app/testData" replace />;
  }

  return <Admin />;
};

// Redirect root-level react-admin routes to /app. Search and hash come along —
// a link that carries state in its query string would otherwise arrive stripped.
const RedirectToApp = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`/app${pathname}${search}${hash}`} replace />;
};

const routesConfig = createRoutesFromElements(
  <Route path="/">
    {/* Redirect from / to /app */}
    <Route index element={<Navigate to="/app" replace />} />
    <Route path="app">
      <Route path="login" element={<SignIn />} />
      {/* Layout route: PrivateRoute wraps all admin routes, stays mounted during navigation */}
      <Route
        element={
          <PrivateRoute>
            <Outlet />
          </PrivateRoute>
        }
      >
        {/* Index route for /app - renders Admin */}
        <Route index element={<AppIndex />} />
        {/* React-admin handles all routes under /app, including /app/Client, /app/User, etc. */}
        <Route path="*" element={<Admin />} />
      </Route>
    </Route>
    {/* Catch-all: redirect root-level react-admin routes (like /Client) to /app/Client */}
    <Route path="*" element={<RedirectToApp />} />
  </Route>,
);

const browserRouter = createBrowserRouter(routesConfig, {});
export const BrowserRouter = () => <RouterProvider router={browserRouter} />;
